function setupCarousel() {
  new Swiper("#na-carousel", {
    direction: "horizontal",
    keyboard: {
      enabled: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    centeredSlides: true,
    slidesPerView: "1",
    loop: true,
    grabCursor: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "bullets",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
setupCarousel();
